import { render, staticRenderFns } from "./SignatureSettings.vue?vue&type=template&id=7b8d5c2c&scoped=true"
import script from "./SignatureSettings.vue?vue&type=script&lang=js"
export * from "./SignatureSettings.vue?vue&type=script&lang=js"
import style0 from "./SignatureSettings.vue?vue&type=style&index=0&id=7b8d5c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8d5c2c",
  null
  
)

export default component.exports